<script>
import {api} from "@/modules/api";
import InputField from "@/components/input/InputField.vue";
import SelectField from "@/components/input/SelectField.vue";
import TextareaField from "@/components/input/TextareaField.vue";
import BreadcrumpAdmin from "@/components/BreadcrumdAdmin.vue";

export default {
  name: 'EditProduct',
  components: {BreadcrumpAdmin, TextareaField, SelectField, InputField},
  data () {
    return {
      product: null,
      options: {},
      apiUrl: process.env.VUE_APP_API_URL
    }
  },
  mounted () {
    this.loadData()
    this.loadOptions()
  },
  methods: {
    async loadOptions () {
      await api.categories.options().then((response) => {
        this.options = response.map((option) => {
          return {
            value: option.id,
            text: option.Label
          }
        })
      })
    },
    async loadData () {
      this.product = await api.products.getById(this.$route.params.id)
    },
    async submitData () {
      const formData = {
        title: this.product.title,
        description: this.product.description,
        price: this.product.price,
        quantity: this.product.quantity,
        categoryId: this.product.categoryId
      }

      api.products.update(this.product.id, formData).then(() => {
        this.$router.push('/admin/product')
      })
    }
  }
}
</script>

<template>
  <section v-if="product" class="p-4 h-auto pt-20">
    <breadcrump-admin
        :first-items="{ text: 'Produits', url: 'app_admin_product' }"
        :second-items="{ text: `#${product.title}` }"
    />
    <div class="grid grid-cols-2 gap-4">
      <div>
        <router-link to="/admin/product"><i class="fa-solid fa-chevron-left mr-2"></i>Retour liste</router-link>
        <div class="my-5">
          <input-field
              v-model="product.title"
              label="Nom produit"
          />
        </div>
        <div class="my-5">
          <select-field
              v-model="product.categoryId"
              label="Catégorie"
              :options="options"
          />
        </div>
        <textarea-field
            v-model="product.description"
            label="Description"
            placeholder="Entrez une description"
        />
        <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-2 gap-4 my-4">
          <input-field
              v-model="product.price"
              type="number"
              label="Prix"
              placeholder="Prix.."
          />
          <input-field
              v-model="product.quantity"
              label="Quantité"
              type="number"
              placeholder="Quantité.."
          />
        </div>
      </div>
      <div>
        <img :src="`${apiUrl}${product.Images[0].url}`" :alt="`Image ${product.title}`">
      </div>
    </div>
    <div class="">
      <button @click="submitData" class="text-white justify-center bg-primary-700 hover:bg-primary-800 focus:ring-4 focus:outline-none focus:ring-primary-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-primary-600 dark:hover:bg-primary-700 dark:focus:ring-primary-800">
        Enregistrer modifications
      </button>
    </div>
  </section>
</template>

<style scoped>

</style>